document.addEventListener('DOMContentLoaded', () => {
  const footerCta = document.querySelector('.global-any-cta');

  if (!footerCta) {
    return;
  }

  let lastScrollTop = 0;
  const SCROLL_THRESHOLD = 200;

  footerCta.classList.add('is-hidden');

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop < SCROLL_THRESHOLD) {
      footerCta.classList.add('is-hidden');
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      return;
    }

    if (scrollTop > lastScrollTop) {
      footerCta.classList.remove('is-hidden');
    } else {
      footerCta.classList.add('is-hidden');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }, false);
});
